import { createApiSaga } from '../../../sagaGenerator';
import {
  apiGet, apiPost, apiPut,
} from '../../../../middleware/api';
import {
  GET_EDIT_VOLCANO_EVENT_REQUEST,
  GET_EDIT_VOLCANO_EVENT_SUCCESS,
  GET_EDIT_VOLCANO_EVENT_FAILURE,
  CREATE_EDIT_VOLCANO_EVENT_REQUEST,
  CREATE_EDIT_VOLCANO_EVENT_SUCCESS,
  CREATE_EDIT_VOLCANO_EVENT_FAILURE,
  UPDATE_EDIT_VOLCANO_EVENT_REQUEST,
  UPDATE_EDIT_VOLCANO_EVENT_SUCCESS,
  UPDATE_EDIT_VOLCANO_EVENT_FAILURE,
  EDIT_VOLCANO_EVENT_LOCATION_REQUEST,
  EDIT_VOLCANO_EVENT_LOCATION_SUCCESS,
  EDIT_VOLCANO_EVENT_LOCATION_FAILURE,
  EDIT_VOLCANO_EVENT_LOCATION_SEARCH_REQUEST,
  EDIT_VOLCANO_EVENT_LOCATION_SEARCH_SUCCESS,
  EDIT_VOLCANO_EVENT_LOCATION_SEARCH_FAILURE,
  EDIT_VOLCANO_EVENT_EARTHQUAKE_REQUEST,
  EDIT_VOLCANO_EVENT_EARTHQUAKE_SUCCESS,
  EDIT_VOLCANO_EVENT_EARTHQUAKE_FAILURE,
  EDIT_VOLCANO_EVENT_EARTHQUAKE_SEARCH_REQUEST,
  EDIT_VOLCANO_EVENT_EARTHQUAKE_SEARCH_SUCCESS,
  EDIT_VOLCANO_EVENT_EARTHQUAKE_SEARCH_FAILURE,
  EDIT_VOLCANO_EVENT_REFERENCE_REQUEST,
  EDIT_VOLCANO_EVENT_REFERENCE_SUCCESS,
  EDIT_VOLCANO_EVENT_REFERENCE_FAILURE,
  EDIT_VOLCANO_EVENT_REFERENCE_SEARCH_REQUEST,
  EDIT_VOLCANO_EVENT_REFERENCE_SEARCH_SUCCESS,
  EDIT_VOLCANO_EVENT_REFERENCE_SEARCH_FAILURE,
  EDIT_VOLCANO_EVENT_TSUNAMI_REQUEST,
  EDIT_VOLCANO_EVENT_TSUNAMI_SUCCESS,
  EDIT_VOLCANO_EVENT_TSUNAMI_FAILURE,
  EDIT_VOLCANO_EVENT_TSUNAMI_SEARCH_REQUEST,
  EDIT_VOLCANO_EVENT_TSUNAMI_SEARCH_SUCCESS,
  EDIT_VOLCANO_EVENT_TSUNAMI_SEARCH_FAILURE,
  EDIT_VOLCANO_EVENT_AGENT_REQUEST,
  EDIT_VOLCANO_EVENT_AGENT_SUCCESS,
  EDIT_VOLCANO_EVENT_AGENT_FAILURE,
} from './volcanoEventEditReducer';

const getVolcanoEventSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/volcanoes/${action.id}`, ...action }),
  requestType: GET_EDIT_VOLCANO_EVENT_REQUEST,
  successType: GET_EDIT_VOLCANO_EVENT_SUCCESS,
  failureType: GET_EDIT_VOLCANO_EVENT_FAILURE,
});

const createVolcanoEventSaga = createApiSaga({
  apiFunction: apiPost,
  generateApiConfig: action => ({ endpoint: '/volcanoes', ...action }),
  requestType: CREATE_EDIT_VOLCANO_EVENT_REQUEST,
  successType: CREATE_EDIT_VOLCANO_EVENT_SUCCESS,
  failureType: CREATE_EDIT_VOLCANO_EVENT_FAILURE,
  successMessage: 'Saved',
});

const updateVolcanoEventSaga = createApiSaga({
  apiFunction: apiPut,
  generateApiConfig: action => ({ endpoint: `/volcanoes/${action.id}`, ...action }),
  requestType: UPDATE_EDIT_VOLCANO_EVENT_REQUEST,
  successType: UPDATE_EDIT_VOLCANO_EVENT_SUCCESS,
  failureType: UPDATE_EDIT_VOLCANO_EVENT_FAILURE,
  successMessage: 'Saved',
});

const getVolcanoLocationSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/volcanoes/${action.id}/location`, ...action }),
  requestType: EDIT_VOLCANO_EVENT_LOCATION_REQUEST,
  successType: EDIT_VOLCANO_EVENT_LOCATION_SUCCESS,
  failureType: EDIT_VOLCANO_EVENT_LOCATION_FAILURE,
});

const getVolcanoLocationsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/volcanolocs', ...action }),
  requestType: EDIT_VOLCANO_EVENT_LOCATION_SEARCH_REQUEST,
  successType: EDIT_VOLCANO_EVENT_LOCATION_SEARCH_SUCCESS,
  failureType: EDIT_VOLCANO_EVENT_LOCATION_SEARCH_FAILURE,
});


const getEarthquakeSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/volcanoes/${action.id}/earthquakes`, ...action }),
  requestType: EDIT_VOLCANO_EVENT_EARTHQUAKE_REQUEST,
  successType: EDIT_VOLCANO_EVENT_EARTHQUAKE_SUCCESS,
  failureType: EDIT_VOLCANO_EVENT_EARTHQUAKE_FAILURE,
});

const searchEarthquakesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/earthquakes', ...action }),
  requestType: EDIT_VOLCANO_EVENT_EARTHQUAKE_SEARCH_REQUEST,
  successType: EDIT_VOLCANO_EVENT_EARTHQUAKE_SEARCH_SUCCESS,
  failureType: EDIT_VOLCANO_EVENT_EARTHQUAKE_SEARCH_FAILURE,
});

const getReferencesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/volcanoes/${action.id}/references`, ...action }),
  requestType: EDIT_VOLCANO_EVENT_REFERENCE_REQUEST,
  successType: EDIT_VOLCANO_EVENT_REFERENCE_SUCCESS,
  failureType: EDIT_VOLCANO_EVENT_REFERENCE_FAILURE,
});

const searchReferencesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/references', ...action }),
  requestType: EDIT_VOLCANO_EVENT_REFERENCE_SEARCH_REQUEST,
  successType: EDIT_VOLCANO_EVENT_REFERENCE_SEARCH_SUCCESS,
  failureType: EDIT_VOLCANO_EVENT_REFERENCE_SEARCH_FAILURE,
});

const getTsunamiSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/volcanoes/${action.id}/tsunamis`, ...action }),
  requestType: EDIT_VOLCANO_EVENT_TSUNAMI_REQUEST,
  successType: EDIT_VOLCANO_EVENT_TSUNAMI_SUCCESS,
  failureType: EDIT_VOLCANO_EVENT_TSUNAMI_FAILURE,
});

const searchTsunamisSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/tsunamis/events', ...action }),
  requestType: EDIT_VOLCANO_EVENT_TSUNAMI_SEARCH_REQUEST,
  successType: EDIT_VOLCANO_EVENT_TSUNAMI_SEARCH_SUCCESS,
  failureType: EDIT_VOLCANO_EVENT_TSUNAMI_SEARCH_FAILURE,
});

const getAgentsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/agents', ...action }),
  requestType: EDIT_VOLCANO_EVENT_AGENT_REQUEST,
  successType: EDIT_VOLCANO_EVENT_AGENT_SUCCESS,
  failureType: EDIT_VOLCANO_EVENT_AGENT_FAILURE,
});

export const volcanoEventEditSagas = [
  getVolcanoEventSaga,
  createVolcanoEventSaga,
  updateVolcanoEventSaga,
  getVolcanoLocationSaga,
  getVolcanoLocationsSaga,
  getEarthquakeSaga,
  searchEarthquakesSaga,
  getReferencesSaga,
  searchReferencesSaga,
  getTsunamiSaga,
  searchTsunamisSaga,
  getAgentsSaga,
];
